export default function Hr({ className = '' }) {
  return <hr className={`border-t border-border ${className}`} />
}
